module.exports = __webpack_public_path__ + "assets/modernizr.2fa9b330.svg";